"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactTextMask = _interopRequireDefault(require("react-text-mask"));

var _GridContainer = _interopRequireDefault(require("vf-comps/build/components/layouts/grid/GridContainer"));

var _GridItem = _interopRequireDefault(require("vf-comps/build/components/layouts/grid/GridItem"));

var _Search = _interopRequireDefault(require("vf-comps/build/components/molecules/inputs/search/Search"));

var _APIsErrorHandling = require("../utils/APIsErrorHandling");

var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));

var _appConstants = require("../constants/appConstants");

var _CardContainer = _interopRequireDefault(require("./CardContainer"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BoxSizing = _interopRequireDefault(require("vf-comps/build/components/layouts/box/boxSizing/BoxSizing"));

var _Loader = _interopRequireDefault(require("vf-comps/build/components/atoms/loader/Loader"));

var _excluded = ["inputRef"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TabContent = function TabContent(_ref) {
  var hasApiError = _ref.hasApiError,
      handleInputChange = _ref.handleInputChange,
      resetPrevSearchValue = _ref.resetPrevSearchValue,
      submits = _ref.submits,
      selectedCategory = _ref.selectedCategory,
      textVal = _ref.textVal,
      error = _ref.error,
      onkeypress = _ref.onkeypress,
      isFetchingData = _ref.isFetchingData,
      regexOfPersonalID = _ref.regexOfPersonalID,
      showResult = _ref.showResult;
  var inputEl = (0, _react.useRef)(null);
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    return state[_appConstants.pkgName];
  }),
      customerDetails = _useSelector.customerDetails,
      customerResponseError = _useSelector.error;

  var t = (0, _useTranslation.default)();
  /**
   * and set selection range on
   * the right position on focus
   */

  var setRange = function setRange() {
    setTimeout(function () {
      inputEl.current.setSelectionRange(textVal.trimEnd().length, textVal.trimEnd().length);
    }, 0);
  };
  /*
     handle masking on inputs
   */


  var TextMaskCustom = (0, _react.useCallback)(function (props) {
    var inputRef = props.inputRef,
        other = _objectWithoutProperties(props, _excluded);

    return /*#__PURE__*/_react.default.createElement(_reactTextMask.default, _extends({}, other, {
      ref: function ref(_ref2) {
        inputRef(_ref2 ? _ref2.inputElement : null);
      },
      mask: new Function('return [' + selectedCategory.maskRegex + '];')(),
      placeholderChar: "\u2000"
    }));
  }, [selectedCategory.maskRegex]);

  var matchRegexPersonalID = function matchRegexPersonalID(val) {
    for (var i = 0; i < regexOfPersonalID.length; i++) {
      var regexExp = new RegExp(regexOfPersonalID[i]);
      var isValid = regexExp.test(val);
      if (isValid) return isValid;
    }
  };

  var onInputChange = function onInputChange(v) {
    var _selectedCategory$mas;

    if (v === '') {
      resetPrevSearchValue();
    }

    var regex = /(\"|\')\s(\"|\')/;
    var isMaskHasSpace = (_selectedCategory$mas = selectedCategory.maskRegex) === null || _selectedCategory$mas === void 0 ? void 0 : _selectedCategory$mas.search(regex);
    var value = isMaskHasSpace === -1 ? v.trim() : v;

    if (selectedCategory.name === 'personalId') {
      if (!matchRegexPersonalID(value.replace(/ /g, ''))) return;
    }

    handleInputChange(value);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_GridContainer.default, {
    justify: "center"
  }, hasApiError ? /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_GridContainer.default, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    md: 6,
    sm: 8,
    xs: 12
  }, (0, _APIsErrorHandling.customerErrorHandling)(customerResponseError, t, dispatch)))) : null, /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    md: 6,
    sm: 8,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "search-input"
  }, /*#__PURE__*/_react.default.createElement(_Search.default, {
    onChange: onInputChange,
    onSubmit: submits,
    placeholder: selectedCategory.placeholderText && t(selectedCategory.placeholderText),
    value: textVal,
    error: error,
    errorText: error ? t(selectedCategory.regexError) : '',
    onFocus: function onFocus() {
      return setRange();
    },
    inputRef: inputEl,
    formHelperTextProps: _objectSpread({}, error && {
      'data-testid': selectedCategory.regexError
    }),
    InputProps: {
      inputComponent: selectedCategory.maskRegex && TextMaskCustom,
      onKeyPress: function onKeyPress(e) {
        onkeypress(e);
      },
      inputProps: {
        'data-testid': 'search-input-field'
      }
    },
    buttonId: 'search-button'
  }))), isFetchingData ? /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    md: 12,
    sm: 12,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_BoxSizing.default, {
    mt: "large"
  }, /*#__PURE__*/_react.default.createElement("span", {
    "data-testid": "customerSearch-loader"
  }, /*#__PURE__*/_react.default.createElement(_Loader.default, {
    color: "red",
    size: "small"
  })))) : customerDetails.length && showResult ? /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_GridContainer.default, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(_GridItem.default, {
    md: 6,
    sm: 8,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_CardContainer.default, {
    customersData: customerDetails,
    cardConfiguration: selectedCategory.cardConfiguration[0]
  })))) : ''));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isFetchingData: state[_appConstants.pkgName].isFetchingData,
    showResult: state[_appConstants.pkgName].showResult
  };
};

TabContent.propTypes = {
  isFetchingData: _propTypes.default.bool,
  showResult: _propTypes.default.bool.isRequired
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(TabContent);

exports.default = _default;